import { render, staticRenderFns } from "./EducatorLog.vue?vue&type=template&id=a9f6ec22"
import script from "./EducatorLog.vue?vue&type=script&lang=ts"
export * from "./EducatorLog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports